import React from 'react';
import { Card } from '@ygtechnologies/rubus-ui';
import { TextView, MarkdownDisplay } from '@ygtechnologies/bygr-frontend-component-library';
import { ConfiguratorPresetGroupDto } from '@/services/configurator';
import { RoomStyleCard } from './RoomStyleCard';
import styles from './RoomStyleGroupCard.module.scss';

export interface RoomStyleGroupCardProps {
    styleGroup: ConfiguratorPresetGroupDto;
}

export const RoomStyleGroupCard: React.FC<RoomStyleGroupCardProps> = ({ styleGroup }) => {
    return (
        <Card className={styles.card}>
            <div className={styles.header}>
                <h4>{styleGroup.name}</h4>
                <TextView>
                    <MarkdownDisplay markdown={styleGroup.description} />
                </TextView>
            </div>

            <div className={styles.list}>
                {styleGroup.styles.map((style) => (
                    <RoomStyleCard key={style.id} style={style} styleGroup={styleGroup} />
                ))}
            </div>
        </Card>
    );
};
